import { AxiosError } from "axios";

import { api } from "@/lib/axios";

type Mentor = {
	id: string;
	name: string;
	image: string;
};

type Lesson = {
	id: string;
	name: string;
	thumbnail: string;
	position: number;
	duration: number;
	available: boolean;
	timeWatched: number;
	watched: boolean;
};

export type Module = {
	id: string;
	name: string;
	position: number;
	available: boolean;
	lessons: Lesson[];
};

export type Training = {
	id: string;
	name: string;
	description: string;
	mentor: Mentor;
	available: boolean;
	type: "free" | "premium";
	image: string;
	modules: Module[];
	percentage: number;
	modulesCount: number;
	lessonsCount: number;
};

export async function showAcademyTraining(id: string): Promise<
	| {
			status: "success";
			data: Training;
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get(`/training/show/${id}`);

		return {
			status: "success",
			data: data.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
